// assessment.guard.ts
import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
// import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AssessmentStateService } from '../lib/assessment-state.service';
import { ErrorPopup } from '../components/alerts/error-popup/error-popup';
import { ModalService } from 'app/lib/modal.service';
// import { AssessmentExitDialogComponent } from './assessment-exit-dialog.component';

export interface CanComponentDeactivate {
  canDeactivate?: () => boolean | Observable<boolean>;
}

@Injectable({ providedIn: 'root' })
export class AssessmentGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(
    // private dialog: MatDialog,
    private modalService: ModalService,
    private assessmentState: AssessmentStateService
  ) {}

  canDeactivate(): Observable<boolean> | boolean {
    // Only block navigation if an assessment is active
    if (!this.assessmentState.isActive) {
      return true;
    }

    // // Show confirmation dialog
    // const dialogRef = this.dialog.open(ErrorPopup, {
    //   width: '480px',
    //   disableClose: true,
    //   panelClass: 'assessment-exit-dialog',
    //   data: {title: "Confirm Exit", message: "Would you like to exit the assessment? Your progress will not be saved."}
    // });

    // return dialogRef.afterClosed();

     return this.modalService
      .showConfirmation(
        'Confirm Exit',
        'You have unsaved progress. Are you sure you want to leave this page?',
        'Yes',
        'Cancel'
      )
      .afterClosed()          
      .pipe(
        map(result => result === true)
      );
  }
}